import CityLandingPage from './CityLandingPage';
import { cityPages } from '@/mocks/cityPages';

const data = cityPages.find((c) => c.slug === 'electronics-recycling-santa-monica')!;
const SantaMonicaPage = () => <CityLandingPage data={data} />;
export default SantaMonicaPage;
